import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { retry, catchError, map } from "rxjs/operators";
import { environment } from "@environments/environment";
import { Loan, Invoice } from "@app/models";
import { AuthenticationService } from "./authentication.service";

@Injectable({ providedIn: "root" })

export class InvoicesService {

  constructor(
    private http: HttpClient,
    private authService: AuthenticationService
  ) { }

  getInvoicesByUser(syncfyUserId: any) {
    let url = `${environment.scs_url_lh}/paybook/transactions/user?id_user=${syncfyUserId}`;
    return this.http.get<any>(url)
      .pipe(map(res => {
        return res;
      }));
  }

  sendInvoiceToReview(dataToReview: any){
    let url = `${environment.scs_url_lh}/factoring/request/store/review`;
    return this.http.post<any>(url, dataToReview)
      .pipe(map(res => {
        return res;
      }));
  }

  getPreapprovalByMerchant(partnerCode: any, merchantExternalUserId: any){
    let url = `${environment.scs_url_lh}/factoring/preapproval?partner_code=${partnerCode}&merchant_external_user_id=${merchantExternalUserId}`;
    return this.http.get<any>(url)
      .pipe(map(res => {
        return res;
      }));
  }

  sendInvoice(dataToReview: any){
    let url = `${environment.scs_url_lh}/portal/register_opportunity`;
    return this.http.post<any>(url, dataToReview)
      .pipe(map(res => {
        return res;
      }));
  }

  getLastTypeExchangeRate() {
    return this.http.get<any>(`${environment.scs_url_lh}/global/get_type_exchange_rate`)
      .pipe(map((res: any) => {
        return res;
      }))

  }

}
